module.exports = require("!!vue-loader!../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./message.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/message.md
// module id = uQgP
// module chunks = 0